export const remixTemplates = [
  {
    name: "Color Fix",
    prompt:
      "Set the lighting on the subject and background to midday lighting. Make the wall color bright white"
  },
  {
    name: "Look at Food",
    prompt:
      "Make the person look at the food"
  }
];


